// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
Rails.start();

// External links
import { startExternalLinks } from "./lib/externalLinks";
startExternalLinks();

// Responsive embeds
import responsiveEmbeds from "./lib/responsiveEmbeds";
responsiveEmbeds();

// Stimulus
import { Application } from "stimulus";
import HeaderController from "./controllers/HeaderController";
const application = Application.start();
application.register("header", HeaderController);

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);

import "./signup/form";
